import { DELETE_ACCOUNT_CUSTOM_VIEW } from "@workspace/account/src/store/actionTypes";
import {
  FETCH_INTERVIEW_COUNT_REQUEST,
  FETCH_INTERVIEW_COUNT_SUCCESS,
  FETCH_INTERVIEW_COUNT_FAILURE,
  FETCH_INTERVIEW_LISTING_REQUEST,
  FETCH_INTERVIEW_LISTING_SUCCESS,
  FETCH_INTERVIEW_LISTING_FAILURE,
  DELETE_INTERVIEWS_REQUEST,
  DELETE_INTERVIEWS_SUCCESS,
  DELETE_INTERVIEWS_FAILURE,
  CREATE_INTERVIEW_CUSTOM_VIEW,
  CREATE_INTERVIEW_CUSTOM_VIEW_SUCCESS,
  CREATE_INTERVIEW_CUSTOM_VIEW_FAILURE,
  FETCH_INTERVIEW_CUSTOM_VIEW,
  FETCH_INTERVIEW_CUSTOM_VIEW_SUCCESS,
  FETCH_INTERVIEW_CUSTOM_VIEW_FAILURE,
  SELECT_INTERVIEW_CUSTOM_VIEW,
  SELECT_INTERVIEW_CUSTOM_VIEW_SUCCESS,
  SELECT_INTERVIEW_CUSTOM_VIEW_FAILURE,
  DELETE_INTERVIEW_CUSTOM_VIEW,
  DELETE_INTERVIEW_CUSTOM_VIEW_SUCCESS,
  DELETE_INTERVIEW_CUSTOM_VIEW_FAILURE,
  RESET_INTERVIEW_CUSTOM_VIEW,
  FETCH_INTERVIEW_CUSTOM_VIEW_BY_ID,
  FETCH_INTERVIEW_CUSTOM_VIEW_BY_ID_SUCCESS,
  FETCH_INTERVIEW_CUSTOM_VIEW_BY_ID_FAILURE,
  EDIT_INTERVIEW_CUSTOM_VIEW_BY_ID,
  EDIT_INTERVIEW_CUSTOM_VIEW_BY_ID_SUCCESS,
  EDIT_INTERVIEW_CUSTOM_VIEW_BY_ID_FAILURE,
  UNSELECT_INTERVIEW_CUSTOM_VIEW,
  UNSELECT_INTERVIEW_CUSTOM_VIEW_SUCCESS,
  UNSELECT_INTERVIEW_CUSTOM_VIEW_FAILURE,
  SET_INTERVIEW_DEFAULT_CUSTOM_VIEW,
  DELETE_INTERVIEW_DEFAULT_CUSTOM_VIEW,
  CANCEL_INTERVIEW_REQUEST,
  CANCEL_INTERVIEW_SUCCESS,
  CANCEL_INTERVIEW_FAILURE,
  ADD_INTERVIEW_LOGS_REQUEST,
  ADD_INTERVIEW_LOGS_SUCCESS,
  ADD_INTERVIEW_LOGS_FAILURE,
  COMPLETE_INTERVIEW_REQUEST,
  COMPLETE_INTERVIEW_SUCCESS,
  COMPLETE_INTERVIEW_FAILURE,
  CREATE_INTERVIEW_REQUEST,
  CREATE_INTERVIEW_SUCCESS,
  CREATE_INTERVIEW_FAILURE,
  TRAIN_CREATE_INTERVIEW_REQUEST,
  TRAIN_CREATE_INTERVIEW_SUCCESS,
  TRAIN_CREATE_INTERVIEW_FAILURE,
  RESCHEDULE_INTERVIEW_REQUEST,
  RESCHEDULE_INTERVIEW_SUCCESS,
  RESCHEDULE_INTERVIEW_FAILURE,
  TRAIN_CANCEL_INTERVIEW_REQUEST,
  TRAIN_CANCEL_INTERVIEW_SUCCESS,
  TRAIN_CANCEL_INTERVIEW_FAILURE,
  TRAIN_RESCHEDULE_INTERVIEW_REQUEST,
  TRAIN_RESCHEDULE_INTERVIEW_SUCCESS,
  TRAIN_RESCHEDULE_INTERVIEW_FAILURE,
  UPLOAD_INTERVIEW_ATTACHMENT_REQUEST,
  UPLOAD_INTERVIEW_ATTACHMENT_SUCCESS,
  UPLOAD_INTERVIEW_ATTACHMENT_FAILURE,
  FETCH_INTERVIEW_BY_MULTI_IDS_REQUEST,
  FETCH_INTERVIEW_BY_MULTI_IDS_SUCCESS,
  FETCH_INTERVIEW_BY_MULTI_IDS_FAILURE,
} from "./actionType";

import {
  errorMetaData,
  pendingMetaData,
  resetAllMetaData,
  successMetaData,
} from "@workspace/common";

const initialState = {
  loading: false,
  data: null,
  error: null,
  interviewCounts: {},
  interviewDetails: {},
  deleteMeta: {},
  interviewCustomView: {},
  interviewCustomViewMeta: {},
  interviewCustomViews: {},
  interviewDefaultCustomView: {},
  interviewAttachments: {},
  interviewSelected: null,
};

const interviewAnalyticsReducer = (state = initialState, action) => {
  switch (action.type) {
    //Interview Counts
    case FETCH_INTERVIEW_COUNT_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_INTERVIEW_COUNT_SUCCESS:
      return { ...state, loading: false, interviewCounts: action.payload };
    case FETCH_INTERVIEW_COUNT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    //Interview Listing
    case FETCH_INTERVIEW_LISTING_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_INTERVIEW_LISTING_SUCCESS:
      return { ...state, loading: false, interviewDetails: action.payload };
    case FETCH_INTERVIEW_LISTING_FAILURE:
      return { ...state, loading: false, error: action.payload };

    //Delete an interview
    case DELETE_INTERVIEWS_REQUEST:
      return { ...state, loading: true, error: false };
    case DELETE_INTERVIEWS_SUCCESS:
      return { ...state, loading: false, deleteMeta: action.payload };
    case DELETE_INTERVIEWS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;

    //Create Interview Custom View
    case CREATE_INTERVIEW_CUSTOM_VIEW:
      return {
        ...state,
        interviewCustomViewMeta: pendingMetaData(),
      };
    case CREATE_INTERVIEW_CUSTOM_VIEW_SUCCESS:
      return {
        ...state,
        interviewCustomView: action.payload,
        interviewCustomViewMeta: successMetaData(action.payload),
      };
    case CREATE_INTERVIEW_CUSTOM_VIEW_FAILURE:
      return {
        ...state,
        errorMsg: action.payload,
        interviewCustomViewMeta: errorMetaData(action.payload),
      };
    //Fetch Interview Custom Views
    case FETCH_INTERVIEW_CUSTOM_VIEW:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case FETCH_INTERVIEW_CUSTOM_VIEW_SUCCESS:
      return {
        ...state,
        loading: false,
        interviewCustomViews: action.payload,
      };
    case FETCH_INTERVIEW_CUSTOM_VIEW_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        errorMsg: action.payload,
      };
    case RESET_INTERVIEW_CUSTOM_VIEW:
      return {
        ...state,
        interviewCustomViews: null,
      };
    //Select Interview Custom View
    case SELECT_INTERVIEW_CUSTOM_VIEW:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case SELECT_INTERVIEW_CUSTOM_VIEW_SUCCESS:
      return {
        ...state,
        loading: false,
        interviewCustomView: action.payload,
      };
    case SELECT_INTERVIEW_CUSTOM_VIEW_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        errorMsg: action.payload,
      };
    //Delete Interview Custom View
    case DELETE_INTERVIEW_CUSTOM_VIEW:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case DELETE_INTERVIEW_CUSTOM_VIEW_SUCCESS:
      return {
        ...state,
        loading: false,
        interviewCustomView: action.payload,
      };
    case DELETE_INTERVIEW_CUSTOM_VIEW_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        errorMsg: action.payload,
      };
    case FETCH_INTERVIEW_CUSTOM_VIEW_BY_ID:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case FETCH_INTERVIEW_CUSTOM_VIEW_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        interviewCustomView: action.payload,
      };
    case FETCH_INTERVIEW_CUSTOM_VIEW_BY_ID_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        errorMsg: action.payload,
      };
    case EDIT_INTERVIEW_CUSTOM_VIEW_BY_ID:
      return {
        ...state,
        interviewCustomViewMeta: pendingMetaData(),
      };
    case EDIT_INTERVIEW_CUSTOM_VIEW_BY_ID_SUCCESS:
      return {
        ...state,
        interviewCustomView: action.payload,
        interviewCustomViewMeta: successMetaData(action.payload),
      };
    case EDIT_INTERVIEW_CUSTOM_VIEW_BY_ID_FAILURE:
      return {
        ...state,
        errorMsg: action.payload,
        interviewCustomViewMeta: errorMetaData(action.payload),
      };
    case UNSELECT_INTERVIEW_CUSTOM_VIEW:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case UNSELECT_INTERVIEW_CUSTOM_VIEW_SUCCESS:
      const newInterviewCustomViews = state.interviewCustomViews.map((view) => {
        if (view?.selected === true) {
          view.selected = false;
        }
        return view;
      });
      return {
        ...state,
        loading: false,
        interviewCustomViews: newInterviewCustomViews,
      };
    case UNSELECT_INTERVIEW_CUSTOM_VIEW_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        errorMsg: action.payload,
      };
    case SET_INTERVIEW_DEFAULT_CUSTOM_VIEW:
      return {
        ...state,
        interviewDefaultCustomView: action.payload,
      };
    case DELETE_INTERVIEW_DEFAULT_CUSTOM_VIEW:
      return {
        ...state,
        interviewDefaultCustomView: {},
      };
    case CANCEL_INTERVIEW_REQUEST:
      return { ...state, loading: true, error: false };
    case CANCEL_INTERVIEW_SUCCESS:
      return { ...state, loading: false, interviewDetails: action.payload };
    case CANCEL_INTERVIEW_FAILURE:
      return { ...state, loading: false, error: action.payload };

    //Add Interview Logs
    case ADD_INTERVIEW_LOGS_REQUEST:
      return { ...state, loading: true, error: false };
    case ADD_INTERVIEW_LOGS_SUCCESS:
      return { ...state, loading: false, interviewDetails: action.payload };
    case ADD_INTERVIEW_LOGS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    //Complete an interview
    case COMPLETE_INTERVIEW_REQUEST:
      return { ...state, loading: true, error: false };
    case COMPLETE_INTERVIEW_SUCCESS:
      return { ...state, loading: false, interviewDetails: action.payload };
    case COMPLETE_INTERVIEW_FAILURE:
      return { ...state, loading: false, error: action.payload };

    //Create Interview
    case CREATE_INTERVIEW_REQUEST:
      return { ...state, loading: true, error: false };
    case CREATE_INTERVIEW_SUCCESS:
      return { ...state, loading: false, interviewDetails: action.payload };
    case CREATE_INTERVIEW_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case TRAIN_CREATE_INTERVIEW_REQUEST:
      return { ...state, loading: true, error: false };
    case TRAIN_CREATE_INTERVIEW_SUCCESS:
      return { ...state, loading: false, interviewDetails: action.payload };
    case TRAIN_CREATE_INTERVIEW_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case RESCHEDULE_INTERVIEW_REQUEST:
      return { ...state, loading: true, error: false };
    case RESCHEDULE_INTERVIEW_SUCCESS:
      return { ...state, loading: false, interviewDetails: action.payload };
    case RESCHEDULE_INTERVIEW_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case TRAIN_CANCEL_INTERVIEW_REQUEST:
      return { ...state, loading: true, error: false };
    case TRAIN_CANCEL_INTERVIEW_SUCCESS:
      return { ...state, loading: false, interviewDetails: action.payload };
    case TRAIN_CANCEL_INTERVIEW_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case TRAIN_RESCHEDULE_INTERVIEW_REQUEST:
      return { ...state, loading: true, error: false };
    case TRAIN_RESCHEDULE_INTERVIEW_SUCCESS:
      return { ...state, loading: false, interviewDetails: action.payload };
    case TRAIN_RESCHEDULE_INTERVIEW_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case UPLOAD_INTERVIEW_ATTACHMENT_REQUEST:
      return { ...state, loading: true, error: false };
    case UPLOAD_INTERVIEW_ATTACHMENT_SUCCESS:
      return { ...state, loading: false, interviewAttachments: action.payload };
    case UPLOAD_INTERVIEW_ATTACHMENT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case FETCH_INTERVIEW_BY_MULTI_IDS_REQUEST:
      return { ...state, loading: true, error: false };
    case FETCH_INTERVIEW_BY_MULTI_IDS_SUCCESS:
      return { ...state, loading: false, interviewSelected: action.payload };
    case FETCH_INTERVIEW_BY_MULTI_IDS_FAILURE:
      return { ...state, loading: false, error: action.payload };
  }
};
export default interviewAnalyticsReducer;
